var productSettings = {
    "Party Pack": {
        name: "Party Pack",
        descriptionStarterPack: 'Can’t decide? We’ve picked three of our best-selling Classic flavors to give you the perfect place to start. Featuring <strong>Chocolate Peanut Butter Banana</strong>, <strong>Strawberries & Cream</strong>, <strong>Green Apple Cinnamon</strong>. Or get all of one flavor!',
        description: 'Can’t decide? We’ve picked four of our best-selling Classic flavors to give you the perfect place to start. Featuring <strong>Chocolate Peanut Butter Banana</strong>, <strong>Strawberries & Cream</strong>, <strong>Green Apple Cinnamon</strong>, and <strong>Mocha Dream</strong>. Or get all of one flavor!',
        bottleImage: 'https://cdn.shopify.com/s/files/1/1209/5722/files/image_product_classic_starterpack_4pk.png?50473',
        include: [
            "Chocolate Peanut Butter Banana",
            "Strawberries & Cream",
            "Green Apple Cinnamon",
            "Mocha Dream",
            "Peach Upside Down Cake",
            "Blueberry Cobbler",
            "Maple Pancakes",
            "Peanut Butter Cookie Dough Cacao Crunch", 
        ]
    },
    "Classic Variety Pack": {
        name: "Classic Variety Pack",
        descriptionStarterPack: 'Can’t decide? We’ve picked three of our best-selling Classic flavors to give you the perfect place to start. Featuring <strong>Chocolate Peanut Butter Banana</strong>, <strong>Strawberries & Cream</strong>, <strong>Green Apple Cinnamon</strong>. Or get all of one flavor!',
        description: 'Can’t decide? We’ve picked four of our best-selling Classic flavors to give you the perfect place to start. Featuring <strong>Chocolate Peanut Butter Banana</strong>, <strong>Strawberries & Cream</strong>, <strong>Green Apple Cinnamon</strong>, and <strong>Mocha Dream</strong>. Or get all of one flavor!',
        bottleImage: 'https://cdn.shopify.com/s/files/1/1209/5722/files/image_product_classic_starterpack_4pk.png?50473',
        include: [
            "Chocolate Peanut Butter Banana",
            "Strawberries & Cream",
            "Green Apple Cinnamon",
            "Mocha Dream"
        ]
    },
    "Dairy-Free Variety Pack": {
        name: "Dairy-Free Variety Pack",
        descriptionStarterPack: 'Can’t decide? Try all three Plant Based flavors in our best-selling variety pack. Featuring <strong>Maple Pancakes</strong>, <strong>Blueberry Cobbler</strong>, <strong>Peanut Butter Cookie Dough Cacao Crunch</strong>. Or get all of one flavor!',
        description: 'Can’t decide? Try all four Plant Based flavors in our best-selling variety pack. Featuring <strong>Maple Pancakes</strong>, <strong>Blueberry Cobbler</strong>, <strong>Peanut Butter Cookie Dough Cacao Crunch</strong>, and <strong>Chai Latte</strong>. Or get all of one flavor!',
        bottleImage: 'https://cdn.shopify.com/s/files/1/1209/5722/files/image_product_plantbased_starterpack_4pk.png?50496',
        include: [
            "Blueberry Cobbler",
            "Maple Pancakes",
            "Peanut Butter Cookie Dough Cacao Crunch", 
            "Chai Latte"
        ]
    },
    "Chocolate Peanut Butter Banana": {
        name: "Chocolate Peanut Butter Banana",
        shortName: "Chocolate",
        handle: "chocolate",
        productImage: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/image_product_chocolatepbbanana_single_shadow_300x.png?v=130574942241571674851603356167',
        nutritionImage: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/Nutritional-Label_CHOCOLATE-PEANUT-BUTTER-BANANA_300x.png?v=3772664420815987831603356197',
        productImageSmall: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/image_product_chocolatepbbanana_single_shadow_50x.png?v=130574942241571674851603356167',
        nutritionImageSmall: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/Nutritional-Label_CHOCOLATE-PEANUT-BUTTER-BANANA_100x.png?v=3772664420815987831603356197',
        bottleImage: 'https://cdn.shopify.com/s/files/1/1209/5722/files/image_product_chocolatepbbananawithbottle_4pk.png?50473',
        backgroundColor: '#873f1e',
        description: 'Chocolate for breakfast! Decadent cocoa, chunks of real banana, and subtle peanut butter undertones come together in a healthy, protein-packed meal that puts sugar-loaded cereals to shame.',
        ingredients: [
            'Real Bananas',
            'Peanut Butter',
            'Ghirardelli Cocoa',
            'Maca Root',
            'Himalayan Pink Salt',
            'Whey Protein'
        ],
        protein: '22',
        sugar: '4',
        icons: [
            'gluten-free',
            // 'dairy-free',
            'contains-peanuts',
            'soy-free',
            // 'tree-nut-free',
        ]

    },
    "Strawberries & Cream": {
        name: "Strawberries & Cream",
        shortName: "Strawberries",
        handle: "strawberries",
        productImage: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/image_product_strawberriescream_single_shadow_300x.png?v=182306906948432100681603356179',
        nutritionImage: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/Nutritional-Label_STRAWBERRIES-AND-CREAM_300x.png?v=127881612903886852931603356201',
        productImageSmall: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/image_product_strawberriescream_single_shadow_50x.png?v=182306906948432100681603356179',
        nutritionImageSmall: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/Nutritional-Label_STRAWBERRIES-AND-CREAM_100x.png?v=127881612903886852931603356201',
        bottleImage: 'https://cdn.shopify.com/s/files/1/1209/5722/files/image_product_strawberrieswithbottle_4pk.png?50473',
        backgroundColor: '#b8213d',
        description: 'Loaded with antioxidants, an excellent source of potassium, and enough Vitamin C to last you all day, including strawberries in your morning routine is an optimal way to start the day. Oh and did we mention it’s straight delicious? “I don’t like strawberries and cream” said no one ever.',
        ingredients: [
            'Real Strawberries',
            'Vermont Maple',
            'Maca Root',
            'Chia / Flax Seeds',
            'Himalayan Pink Salt',
            'Whey Protein'
        ],
        protein: '22',
        sugar: '5',
        icons: [
            'gluten-free',
            //'dairy-free',
            //'contains-peanuts',
            'soy-free',
            'tree-nut-free',
        ]

    },
    "Green Apple Cinnamon": {
        name: "Green Apple Cinnamon",
        shortName: "Green Apple",
        handle: "green-apple",
        productImage: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/image_product_greenapple_single_shadow_300x.png?v=8927959236503049931603356173',
        nutritionImage: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/Nutritional-Label_GREEN-APPLE-CINNAMON_300x.png?v=152661980544207198541603356198',
        productImageSmall: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/image_product_greenapple_single_shadow_50x.png?v=8927959236503049931603356173',
        nutritionImageSmall: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/Nutritional-Label_GREEN-APPLE-CINNAMON_100x.png?v=152661980544207198541603356198',
        bottleImage: 'https://cdn.shopify.com/s/files/1/1209/5722/files/image_product_greenapplewithbottle_4pk.png?50473',
        backgroundColor: '#86c23e',
        description: 'Tart apples sweetened with a dash of cinnamon and maple. This isn’t Nana’s apple pie. Unless Nana made pie with 32g of protein and could bench press Papa.',
        ingredients: [
            'Granny Smith Apples',
            'Cinnamon',
            'Vermont Maple',
            'Maca Root',
            'Chia / Flax Seeds',
            'Whey Protein'
        ],
        protein: '22',
        sugar: '5',
        icons: [
            'gluten-free',
            //'dairy-free',
            //'contains-peanuts',
            'soy-free',
            'tree-nut-free',
        ]

    },
    "Peach Upside Down Cake": {
        name: "Peach Upside Down Cake",
        shortName: "Peach Upside",
        handle: "peach-upside",
        productImage: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/image_product_peachcake_single_shadow_300x.png?v=146371574124914323141603356176',
        nutritionImage: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/Nutritional-Label_PEACH-UPSIDE-DOWN-CAKE_300x.png?v=11173337174239972061603356200',
        productImageSmall: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/image_product_peachcake_single_shadow_50x.png?v=146371574124914323141603356176',
        nutritionImageSmall: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/Nutritional-Label_PEACH-UPSIDE-DOWN-CAKE_100x.png?v=11173337174239972061603356200',
        bottleImage: 'https://cdn.shopify.com/s/files/1/1209/5722/files/image_product_peachcakewithbottle_4pk.png?50473',
        backgroundColor: '#f37788',
        description: 'Flip boring breakfast upside down! Wake up to a summer picnic each morning with Peach Upside Down Cake, a delightful mix of California peaches, cake batter notes, and none of the guilt.',
        ingredients: [
            'Real Peaches',
            'Vermont Maple',
            'Maca Root',
            'Chia / Flax Seeds',
            'Himalayan Pink Salt',
            'Whey Protein'
        ],
        protein: '22',
        sugar: '6',
        icons: [
            'gluten-free',
            //'dairy-free',
            //'contains-peanuts',
            'soy-free',
            'tree-nut-free',
        ]

    },
    "Mocha Dream": {
        name: "Mocha Dream",
        shortName: "Mocha Dream",
        handle: "mocha-dream",
        productImage: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/image_product_mocha_single_shadow_300x.png?v=57824427880414657901603356175',
        nutritionImage: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/Nutritional-Label_MOCHA-DREAM_300x.png?v=96281402236683550251603356199',
        productImageSmall: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/image_product_mocha_single_shadow_50x.png?v=57824427880414657901603356175',
        nutritionImageSmall: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/Nutritional-Label_MOCHA-DREAM_100x.png?v=96281402236683550251603356199',
        bottleImage: 'https://cdn.shopify.com/s/files/1/1209/5722/files/image_product_mochadreamwithbottle_4pk.png?50473',
        backgroundColor: '#b1775c',
        description: 'With as much caffeine as a cup of coffee, a decadent flavor profile, your barista won\'t believe there are also superfoods and 32g of protein inside. Now you can skip the drive thru and the coffee shop - dreams really do come true.',
        ingredients: [
            'Coffee',
            'Raw Cacao',
            'Maca Root',
            'Chia / Flax Seeds',
            'Himalayan Pink Salt',
            'Whey Protein'
        ],
        protein: '22',
        sugar: '4',
        icons: [
            'gluten-free',
            //'dairy-free',
            //'contains-peanuts',
            'soy-free',
            'tree-nut-free',
        ]

    },
    "Blueberry Cobbler": {
        name: "Blueberry Cobbler",
        shortName: "Blueberry",
        handle: "blueberry",
        productImage: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/image_product_blueberrycobbler_single_shadow_300x.png?v=100173506860320174721603356165',
        nutritionImage: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/Nutritional-Label_BLUEBERRY-COBBLER_300x.png?v=56777068058797952631603356197',
        productImageSmall: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/image_product_blueberrycobbler_single_shadow_50x.png?v=100173506860320174721603356165',
        nutritionImageSmall: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/Nutritional-Label_BLUEBERRY-COBBLER_100x.png?v=56777068058797952631603356197',
        bottleImage: 'https://cdn.shopify.com/s/files/1/1209/5722/files/image_product_blueberrywithbottle_4pk.png?50473',
        backgroundColor: '#674ea2',
        description: 'Jammed with antioxidants, loaded with fiber, and bursting with vitamins and minerals, the blueberry is the ultimate superfood, and, you know, cobbler is delicious.',
        ingredients: [
            'Real Blueberries',
            'Vermont Maple',
            'Chia Seeds',
            'Raw Hemp Hearts',
            'Himalayan Pink Salt',
            'Pea Protein'
        ],
        protein: '20',
        sugar: '9',
        icons: [
            'gluten-free',
            'dairy-free',
            //'contains-peanuts',
            'soy-free',
            //'tree-nut-free',
        ]

    },
    "Maple Pancakes": {
        name: "Maple Pancakes",
        shortName: "Maple",
        handle: "maple",
        productImage: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/image_product_maplepancakes_single_shadow_shadow_300x.png?v=38091462026914637691603356174',
        nutritionImage: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/Nutritional-Label_MAPLE-PANCAKES_300x.png?v=113916508363614605581603356199',
        productImageSmall: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/image_product_maplepancakes_single_shadow_shadow_50x.png?v=38091462026914637691603356174',
        nutritionImageSmall: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/Nutritional-Label_MAPLE-PANCAKES_100x.png?v=113916508363614605581603356199',
        bottleImage: 'https://cdn.shopify.com/s/files/1/1209/5722/files/image_product_pancakeswithbottle_4pk.png?50473',
        backgroundColor: '#FDC306',
        description: 'Have you ever tried eating pancakes with maple syrup in your car on the way to work? We wouldn’t recommend it. Well, until now. With 21g+ of protein and zero morning prep, you can start living your best life tomorrow.',
        ingredients: [
            'Vermont Maple',
            'Rich Molasses',
            'Maca Root',
            'Chia / Flax Seeds',
            'Raw Hemp Hearts',
            'Pea Protein'
        ],
        protein: '20',
        sugar: '9',
        icons: [
            'gluten-free',
            'dairy-free',
            //'contains-peanuts',
            'soy-free',
            //'tree-nut-free',
        ]

    },
    "Peanut Butter Cookie Dough Cacao Crunch": {
        name: "Peanut Butter Cookie Dough Cacao Crunch",
        shortName: "Peanut Butter",
        handle: "peanut-butter",
        productImage: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/image_product_peanutbuttercookiedough_single_shadow_300x.png?v=174838981052733760041603356177',
        nutritionImage: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/Nutritional-Label_PEANUT-BUTTER-COOKIE-DOUGH-CACAO-CRUNCH_300x.png?v=97772923891821816511603356200',
        productImageSmall: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/image_product_peanutbuttercookiedough_single_shadow_50x.png?v=174838981052733760041603356177',
        nutritionImageSmall: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/Nutritional-Label_PEANUT-BUTTER-COOKIE-DOUGH-CACAO-CRUNCH_100x.png?v=97772923891821816511603356200',
        bottleImage: 'https://cdn.shopify.com/s/files/1/1209/5722/files/image_product_peanutbutterwithbottle_4pk.png?50473',
        backgroundColor: '#fd8638',
        description: 'Inside this complex flavor profile is an Amazonian superfood with the highest plant-based source of iron known to man: raw cacao. Chances are, your diet is deficient in iron, magnesium, and cookie dough - we’re here to help.',
        ingredients: [
            'Peanut Butter',
            'Raw Cacao',
            'Vermont Maple',
            'Chia Seeds',
            'Himalayan Pink Salt',
            'Pea Protein'
        ],
        protein: '20',
        sugar: '9',
        icons: [
            'gluten-free',
            'dairy-free',
            'contains-peanuts',
            //'soy-free',
            //'tree-nut-free',
        ]

    },
    "Chai Latte": {
        name: "Chai Latte",
        shortName: "Chai Latte",
        handle: "chai-latte",
        productImage: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/image_product_chailatte_single_shadow_300x.png?v=16161795298653037861603356166',
        nutritionImage: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/Nutritional-Label_CHAI-LATTE_300x.jpg?v=18236883655405802301603356197',
        productImageSmall: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/image_product_chailatte_single_shadow_50x.png?v=16161795298653037861603356166',
        nutritionImageSmall: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/Nutritional-Label_CHAI-LATTE_100x.jpg?v=18236883655405802301603356197',
        bottleImage: 'https://cdn.shopify.com/s/files/1/1209/5722/files/image_product_chailattewithbottle_4pk.png?50473',
        backgroundColor: '#c089d0',
        description: 'Chai spices come together with caffeine-rich black tea and Vermont maple for a sweet and spiced jumpstart to your morning. Guaranteed to make you hit snooze one (or four) less times tomorrow.',
        ingredients: [
            'Black Tea',
            'Rich Spice Blend',
            'Vermont Maple',
            'Maca Root',
            'Himalayan Pink Salt',
            'Pea Protein'
        ],
        protein: '20',
        sugar: '9',
        icons: [
            'gluten-free',
            'dairy-free',
            //'contains-peanuts',
            'soy-free',
            //'tree-nut-free',
        ]

    },
    "Pumpkin Spice": {
        name: "Pumpkin Spice",
        shortName: "Pumpkin",
        handle: "pumpkin",
        productImage: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/image_product_pumpkin_single_shadow_300x.png?v=106824183180649558041603356178',
        nutritionImage: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/Nutritional-Label_PUMPKIN-SPICE_300x.png?v=161221196620664682381603356201',
        productImageSmall: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/image_product_pumpkin_single_shadow_50x.png?v=106824183180649558041603356178',
        nutritionImageSmall: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/Nutritional-Label_PUMPKIN-SPICE_100x.png?v=161221196620664682381603356201',
        bottleImage: 'https://cdn.shopify.com/s/files/1/1209/5722/files/image_product_pumpkinwithbottle_4pk.png?51595',
        backgroundColor: '#F47919',
        description: 'With real pumpkin, maple sugar, and a blend of premium spices, this not-so-basic Pumpkin Spice overnight oats shake will knock your UGGs off. Throw on a comfy sweater and hit the ground running with 20g+ of protein, superfoods, and all the flavor!',
        ingredients: [
            'PUMPKIN',
            'CINNAMON',
            'NUTMEG',
            'TURMERIC',
            'CARDAMOM',
            'MACA ROOT',
            'FAVA BEAN PROTEIN',
            'WHOLE GRAIN ROLLED OATS'
        ],
        protein: '20',
        sugar: '9',
        icons: [
            'gluten-free',
            'dairy-free',
            //'contains-peanuts',
            'soy-free',
            //'tree-nut-free',
        ]

    },
    "Gingerbread": {
        name: "Gingerbread",
        shortName: "Gingerbread",
        handle: "gingerbread",
        productImage: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/image_product_gingerbread_single_shadow_300x.png?v=167229398987325916581603356168',
        nutritionImage: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/Nutritional-Label_GINGERBREAD_300x.jpg?v=34591465267874532661603356198',
        productImageSmall: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/image_product_gingerbread_single_shadow_50x.png?v=167229398987325916581603356168',
        nutritionImageSmall: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/Nutritional-Label_GINGERBREAD_100x.jpg?v=34591465267874532661603356198',
        backgroundColor: '#0d7b46',
        description: 'With 21g+ of protein, maple sugar, ginger, molasses, cinnamon, and maca root for energy, this Gingerbread overnight oats shake will power you through the busy holiday season! Limited time only!',
        ingredients: [
            'Rich Molasses',
            'Ginger',
            'Vermont Maple', 
            'Cinnamon',
            'Vanilla Bean',
            'Whey Protein'
        ],
        protein: '21', 
        sugar: '8',
        icons: [
            'gluten-free', 
            // 'dairy-free',
            //'contains-peanuts',
            'soy-free',
            'tree-nut-free',
        ]
    },
    "Birthday Cake": {
        name: "Birthday Cake",
        shortName: "Birthday Cake",
        handle: "birthday-cake",
        productImage: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/image_product_birthday_single_shadow_300x.png?v=121317921698588092781603356164',
        nutritionImage: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/Nutritional-Label_BIRTHDAY_300x.jpg?v=147970712888541821871603356196',
        productImageSmall: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/image_product_birthday_single_shadow_50x.png?v=121317921698588092781603356164',
        nutritionImageSmall: '//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/Nutritional-Label_BIRTHDAY_100x.jpg?v=147970712888541821871603356196',
        backgroundColor: '#3ab9cf',
        description: 'With 21g+ of protein, maple sugar, ginger, molasses, cinnamon, and maca root for energy, this Gingerbread overnight oats shake will power you through the busy holiday season! Limited time only!',
        ingredients: [
            'Vanilla Bean',
            'Maca Root',
            'Chia Seeds', 
            'Raw Hemp Hearts',
            'Himalayan Pink Salt',
            'Whey Protein'
        ],
        protein: '22', 
        sugar: '8',
        icons: [
            'gluten-free', 
            // 'dairy-free', 
            //'contains-peanuts',
            'soy-free',
            'tree-nut-free', 
        ]
    }
};